import { PostgrestError } from '@supabase/supabase-js';

export class AppError extends Error {
  constructor(
    message: string,
    public code?: string,
    public status?: number
  ) {
    super(message);
    this.name = 'AppError';
  }
}

export function handleSupabaseError(error: PostgrestError): AppError {
  switch (error.code) {
    case '23505':
      return new AppError('Duplicate record found', error.code, 409);
    case '23503':
      return new AppError('Referenced record not found', error.code, 404);
    case 'PGRST116':
      return new AppError('Record not found', error.code, 404);
    default:
      return new AppError(error.message, error.code, 500);
  }
}

export function isPostgrestError(error: unknown): error is PostgrestError {
  return typeof error === 'object' && error !== null && 'code' in error;
} 